'use client'

import type { FC } from 'react'
import { useLocalisation } from '@/tools/i18n/client'
import { getImageUrl } from '@/tools/image-service/client'
import { Button, ButtonVariants, ModalDialog, ModalDialogVariant } from '@/tools/ui'

interface Props {
  onClose: () => void
  onConfirmDelete: () => void
  isOpen: boolean
  isLoading: boolean
}

export const DeleteAddressModal: FC<Props> = ({
  onClose: handleClose,
  onConfirmDelete: handleConfirmDelete,
  isOpen,
  isLoading,
}) => {
  const { t } = useLocalisation()

  const imageSource = getImageUrl({
    source: 'dh:/customer-assets-glovo/address_flow/address_book/address_deletion.svg',
  })

  const cancelButton = (
    <Button
      block
      label={t('address-details.delete-modal.keep-button')}
      variant={ButtonVariants.neutral}
      onClick={handleClose}
    />
  )

  const confirmDeleteButton = (
    <Button
      block
      label={t('common.delete')}
      loading={isLoading}
      variant={ButtonVariants.critical}
      onClick={handleConfirmDelete}
    />
  )
  return (
    <>
      <ModalDialog
        body={t('address-details.delete-modal.body')}
        cancelButton={cancelButton}
        confirmButton={confirmDeleteButton}
        imgAlt={t('address-details.delete-modal.image-alt')}
        imgSrc={imageSource}
        isOpen={isOpen}
        title={t('address-details.delete-modal.title')}
        variant={ModalDialogVariant.destructive}
        onClose={handleClose}
      />
    </>
  )
}
